import type { AcquisitionChannel } from "@ternary/contracts"
import { Badge } from "@ternary/ui"
import type { ReactElement } from "react"

const CHANNEL_LABELS: Record<AcquisitionChannel, string> = {
  meta: "Meta",
  tiktok: "TikTok",
  google: "Google",
  x: "X",
  discord: "Discord",
  referral: "Referral",
  direct: "Direct",
}

/** The name an admin sees for an acquisition channel, such as "TikTok". */
export function channelLabel(channel: AcquisitionChannel): string {
  return CHANNEL_LABELS[channel]
}

/**
 * Where a customer came from, named in text on the neutral badge. Seven colours could not be told
 * apart reliably, least of all by colour-blind admins (design call 3). X reads "X (Twitter)" on
 * screen, where a lone "X" in a pill looks like a close button; exports keep `channelLabel`'s
 * "X" (ruling R19).
 */
export function ChannelBadge({ channel }: { channel: AcquisitionChannel }): ReactElement {
  return <Badge>{channel === "x" ? "X (Twitter)" : channelLabel(channel)}</Badge>
}
